import React, {useEffect} from "react"
import qs from "qs"
import everflowTracker from "@irati/ads/utils/everflow"

interface Props {
  dealId?: string
}

const AdsTrack: React.FC<Props> = ({dealId}) => {
  useEffect(() => {
    if (dealId) {
      const q = qs.parse(window.location.search.replace("?", "")) ?? {}
      if (typeof q.tid === "string") {
        everflowTracker.setTid(dealId, q.tid)
      }
    }
  }, [dealId])

  return null
}

export default AdsTrack
